import { DatePipe } from '@angular/common';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import {
  provideTransloco,
  Translation,
  TranslocoLoader,
} from '@jsverse/transloco';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';
import { Observable } from 'rxjs';

import { environment } from '../environments/environment';

import { appRoutes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { loadLang } from './core/initializers/app.initializer';
import { AI_GATEWAY_SERVICE } from './features/workspace/data-access/ai-gateway.service';
import { DefaultAiGatewayService } from './features/workspace/data-access/default-ai-gateway.service';

export class CustomTranslocoLoader implements TranslocoLoader {
  #http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this.#http.get<Translation>(`/i18n/${lang}.json`);
  }
}

export function tokenGetter() {
  return localStorage.getItem('accessToken');
}

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    importProvidersFrom(BrowserModule),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(loadLang),
    provideZonelessChangeDetection(),
    provideTransloco({
      config: {
        availableLangs: ['en', 'ru'],
        defaultLang: 'en',
        prodMode: environment.production,
        reRenderOnLangChange: true,
      },
      loader: CustomTranslocoLoader,
    }),
    provideTranslocoPersistLang({
      storage: {
        useValue: localStorage,
      },
    }),
    JwtModule.forRoot({
      config: {
        allowedDomains: [environment.apiUrl],
        tokenGetter: tokenGetter,
      },
    }).providers ?? [],

    { provide: AI_GATEWAY_SERVICE, useClass: DefaultAiGatewayService },
  ],
};
